import Icon from '../components/Icon.vue'

Icon.register({
  list: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M128 116V76C128 67.2 135.2 60 144 60H496C504.8 60 512 67.2 512 76V116C512 124.8 504.8 132 496 132H144C135.2 132 128 124.8 128 116zM144 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H144C135.2 220 128 227.2 128 236V276C128 284.8 135.2 292 144 292zM144 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H144C135.2 380 128 387.2 128 396V436C128 444.8 135.2 452 144 452zM16 144H80C88.8 144 96 136.8 96 128V64C96 55.2 88.8 48 80 48H16C7.2 48 0 55.2 0 64V128C0 136.8 7.2 144 16 144zM16 304H80C88.8 304 96 296.8 96 288V224C96 215.2 88.8 208 80 208H16C7.2 208 0 215.2 0 224V288C0 296.8 7.2 304 16 304zM16 464H80C88.8 464 96 456.8 96 448V384C96 375.2 88.8 368 80 368H16C7.2 368 0 375.2 0 384V448C0 456.8 7.2 464 16 464z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/list.js
// module id = eP+q
// module chunks = 144